import React from 'react';
import cn from 'classnames';
import { wpToCF } from '../../utils/data/cdn';

interface Props {
  image?: string;
  name: string;
  className?: string;
}

const Avatar = ({ image, name, className }: Props) => {
  const classes = cn(className, 'w-full h-full rounded-full');
  if (!image) {
    return <div className={cn(classes, 'bg-gray-800')} />;
  }

  return (
    <img src={wpToCF(image)} alt={name} className={cn(classes, 'block')} />
  );
};

export default Avatar;
